module.exports = __webpack_public_path__ + "img/marron-3.d11ac7ac.png";